module.exports = __webpack_public_path__ + "static/media/drugsgray.3f0c8c80.png";